(function () {
    if (!avail("URLSearchParams")) return;
    if (!avail("fetch")) return;
    if (!avail("Promise")) return;
    const script = document.querySelector("script[src*=google-one-tap-assets]");
    const src = script.getAttribute("src");
    const search = new URLSearchParams(src.slice(src.indexOf("?")));
    const clientId = search.get("jsKey");
    if (!clientId) return;
    const div = document.createElement("div");
    div.id = "g_id_onload";
    div.setAttribute("data-prompt_parent_id", "g_id_onload");
    div.setAttribute("style", "position: absolute; right: 0; z-index: 1000000001;");
    div.setAttribute("data-client_id", clientId);
    div.setAttribute("data-callback", "handleCredentialResponse");
    document.body.insertAdjacentElement("afterbegin", div);

    const scriptTag = document.createElement("script");
    scriptTag.src = "https://accounts.google.com/gsi/client";

    document.body.appendChild(scriptTag);

    function avail(func) {
        return func in window;
    }

})();

window.handleCredentialResponse = function (credentials) {

    window.dispatchEvent(new Event("signinStarted"));

    fetch("/auth/api/v1/authentication/tap",
        {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({
                provider: "google",
                idToken: credentials.credential
            }),
            headers: {
                'Content-Type': "application/json"
            }
        })
        .then(response => {
            if (response.ok)
                return response.json();
            throw new Error(`Failed with HTTP code ${response.status}`);
        })
        .then(data => {

            const params = (new URL(document.location)).searchParams;
            if (!params.has("ret") && !params.has("return"))
                params.append("ret", document.location.href);
            const qps = Array
                .from(params.keys())
                .reduce((acc, cv) => (acc.push(`${cv}=${encodeURIComponent(params.get(cv))}`), acc), []);
            window.location.replace(`${data.ssoPath}&${qps.join("&")}`);
            window.dispatchEvent(new Event("signinEnded"));
        })
        .catch((error) => {
            window.dispatchEvent(new Event("signinFailed"));
        });
}



